export default {
  id: null,
  nome: '',
  username: '',
  password: '',
  paId: null,
  tipoUsuario: null,
  mesasIds: [],
  midiasIds: []
}



// WEBPACK FOOTER //
// ./src/shared/models/configurations/totemmodel.js